<div *ngIf="!hidden" id="waitLoader">
  <div class="loaderContainer">
      <img class="rotating" style="width: 80px; height: 80px;" src="/assets/spinner_Unit4.svg" />
  </div>
</div>